/* eslint-disable */
export const imgUrl = (teamId) => `https://www.europaleague.gr/betarades/cdn/teams/${teamId}.png`;

export const categories = {
  standings: ['standings'],
  scorers: ['scorers'],
  teamTotalStats: ['teamTotalStats'],
  leagueStats: ['leagueStats'],
  matcheProgram: ['previousMatches', 'nextMatches'],
  halves: ['halves'],
  goals: ['goals01', 'goals02', 'goals23', 'goals3', 'goals46', 'goals7'],
  streaks: ['mostWins', 'mostLoses', 'mostDraws','mostDrawsStreak','mostWinsStreak', 'mostLossStreak'],
  noStreaks: ['noWinStreak', 'noLossStreak'],
  ngGg: ['mostGoalGoal', 'mostNoGoal'],
  card: ['yellowCards', 'redCards'],
  htFt: ['home11', 'home1X','home12','homeX1','homeXX','homeX2','home21','home2X','home22', 'away11', 'away1X', 'away12', 'awayX1', 'awayXX', 'awayX2', 'away21', 'away2X', 'away22'],
  overUnder: ['mostOver25', 'mostUnder25'],
};

export const standingsCorrections = {
  el: 'Διορθώσεις',
  en: 'Standings Corrections'
}

export const topScrorers = {
  el: 'Πρώτοι σκόρερ',
  en: 'Top Scorers' 
}

export const standingsMainTableSubtitle = {
  el: 'ΒΑΘΜΟΛΟΓΙΚΟΣ ΠΙΝΑΚΑΣ',
  en: 'STANDINGS TABLE' 
}

export const standingsTitle = {
  el: 'Βαθμολογία',
  en: 'Standing' 
}

export const flagUrl = 'https://wbsearthcomps-5c24.kxcdn.com/';

export const singleTeamArrays = ['mostWins', 'mostLoses', 'mostDraws', 'mostDrawsStreak', 'mostWinsStreak', 'mostLossStreak', 'noWinStreak', 'noLossStreak',  'mostGoalGoal', 'mostNoGoal', 'mostOver25', 'mostUnder25'];
export const pairs = ['goals','streaks','noStreaks','ngGg','card','htFt','overUnder', 'matcheProgram'];
export const firstColumnCenter = ['yellowCards', 'redCards', 'mostOver25', 'mostUnder25', 'mostWins', 'mostLoses', 'mostDraws','mostDrawsStreak','mostWinsStreak', 'mostLossStreak'];
export const corsMessage = {
  el: 'Η υπηρεσία είναι απενεργοποιημένη για τον ιστότοπό σας, παρακαλώ επικοινωνήστε μαζί μας στο support@betwidgets.com',
  en: 'This service is unavailable for your website, please contact us at support@betwidgets.com'
}

export const chooseCompetition = {
  el:"Επίλεξε πρωτάθλημα:",
  en: 'Choose competition:'
}

export const legendColors = {
  1 : '#0EA156',
  2 : '#13B899',
  3 : '#0881BA',
  4 : '#1CADF1',
  5 : '#333',
  6 : '#E13636',
  7 : '#CAA210',
  8 : '#0EA156',
  9 : '#13B899',
  10: '#82CC0A',
  11: '#CAA210',
  12: '#CAA210',
  13: '#0EA156',
  14: '#0881BA',
  15: '#0EA156',
  16: '#CAA210',
  17: '#29a9e8',
  18: '#0EA156',
}



// WEBPACK FOOTER //
// ./src/constants.js